export const getResponse = (status, data = null, error = null) => {
  return { status, ...(data != null ? data : error) };
};
